import React from 'react';
import { compose } from 'ramda';
import { RouteComponentProps } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@deeptrue-frontend/ui';
import styled from 'styled-components/macro';
import { useFormatMessage } from 'components/IntlProvider';
import RouterProvider from 'components/RouterProvider/RouterProvider';

const Wrapper = styled.div`
  postiion: relative;
`;

const { withRouter } = RouterProvider;

interface EmptyPlaceholderProps {
  children: React.ReactNode;
  hasValues: boolean;
  isLoaded: boolean;
  history: RouteComponentProps['history'];
  withLoader?: boolean;
  info?: string;
}

const EmptyPlaceholder = ({
  children,
  isLoaded = false,
  hasValues,
  withLoader = false,
  info,
}: EmptyPlaceholderProps) => {
  const t = useFormatMessage();

  if (!isLoaded && withLoader && !hasValues) {
    return (
      <Grid container justify="center">
        <CircularProgress />
      </Grid>
    );
  }
  if (isLoaded && !hasValues) {
    return (
      <Grid container justify="center">
        <Typography>
          {info
            ? info
            : t(
                'placeholder.text',
                'No results. We have nothing to show here.'
              )}
        </Typography>
      </Grid>
    );
  }
  return (
    <Wrapper>
      {!isLoaded && withLoader && (
        <Grid container justify="center">
          <CircularProgress />
        </Grid>
      )}
      {children}
    </Wrapper>
  );
};

export default compose(withRouter)(EmptyPlaceholder);
